import * as React from "react"

const MOBILE_BREAKPOINT = 1024

function isIPad(): boolean {
  // Check for iPad specifically
  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /ipad|iphone|ipod/.test(userAgent)
  const isTablet = /ipad/.test(userAgent) || 
    (isIOS && window.screen.width >= 768) ||
    (navigator.maxTouchPoints > 1 && /macintosh/.test(userAgent))
  
  return isTablet
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      // Treat iPads as desktop devices regardless of screen size
      const isPadDevice = isIPad()
      setIsMobile(!isPadDevice && window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    
    // Initial check
    const isPadDevice = isIPad()
    setIsMobile(!isPadDevice && window.innerWidth < MOBILE_BREAKPOINT)
    
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const checkIsTablet = () => {
      const isPadDevice = isIPad()
      const isLargeScreen = window.innerWidth >= 768 && window.innerWidth < MOBILE_BREAKPOINT
      setIsTablet(isPadDevice || isLargeScreen)
    }

    checkIsTablet()
    window.addEventListener("resize", checkIsTablet)
    return () => window.removeEventListener("resize", checkIsTablet)
  }, [])

  return !!isTablet
}

export function useIsMobileOrTablet() {
  const [is, setIs] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const check = () => {
      setIs(window.innerWidth < MOBILE_BREAKPOINT || isIPad())
    }
    check()
    window.addEventListener("resize", check)
    return () => window.removeEventListener("resize", check)
  }, [])

  return !!is
}
